import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: "",
  confirmationDialog: false,
  projectModal: false,
  idToBeDeleted: 0,
};

const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    search(state, action) {
      state.search = action.payload;
    },
    controlConfirmationDialog(state) {
      state.confirmationDialog = !state.confirmationDialog;
    },
    controlProjectModal(state) {
      state.projectModal = !state.projectModal;
    },
    setIdToBeDeleted(state, action) {
      state.idToBeDeleted = action.payload;
    },
  },
});

export const {
  search,
  controlConfirmationDialog,
  controlProjectModal,
  setIdToBeDeleted,
} = projectsSlice.actions;
export default projectsSlice.reducer;
